import { render, staticRenderFns } from "./yConfirmModal.vue?vue&type=template&id=397a5be5&scoped=true"
import script from "./yConfirmModal.vue?vue&type=script&lang=js"
export * from "./yConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./yConfirmModal.vue?vue&type=style&index=0&id=397a5be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a5be5",
  null
  
)

export default component.exports